import { action, makeObservable, observable } from 'mobx';
import { BatteryDataSet } from 'src/integration/types/BatteryDataSet';

class BatteryStore {
  @observable batteryData: BatteryDataSet[] = [];

  @action setBatteryData = (data: SimpleObject[]) => {
    this.batteryData = data as BatteryDataSet[];
  };

  constructor() {
    makeObservable(this);
  }
}

export default BatteryStore;
